var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-link",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.126,6.092l-0,3.701c-0.002,1.299 -0.498,2.598 -1.49,3.59c-0.991,0.991 -2.29,1.488 -3.59,1.489c-0.258,0 -0.516,-0.098 -0.713,-0.295c-0.394,-0.394 -0.394,-1.033 0,-1.427c0.197,-0.197 0.455,-0.296 0.713,-0.296c0.783,-0.001 1.566,-0.3 2.164,-0.898c0.597,-0.597 0.896,-1.38 0.897,-2.163l0,-3.7c0,-0.784 -0.298,-1.568 -0.896,-2.165c-1.196,-1.196 -3.134,-1.196 -4.329,-0c-0.598,0.597 -0.897,1.381 -0.897,2.165l-0,1.523c0,0.259 -0.098,0.518 -0.296,0.715c-0.394,0.394 -1.033,0.394 -1.427,-0c-0.197,-0.197 -0.296,-0.456 -0.295,-0.715l-0,-1.523c-0.001,-1.302 0.495,-2.603 1.487,-3.596c1.984,-1.983 5.2,-1.983 7.184,0c0.993,0.993 1.489,2.294 1.488,3.595Zm-2.019,10.318c0,-0.258 0.099,-0.517 0.296,-0.714c0.394,-0.394 1.033,-0.394 1.427,0c0.197,0.197 0.296,0.456 0.296,0.714l-0,1.523c-0.001,1.299 -0.497,2.598 -1.488,3.589c-1.984,1.983 -5.2,1.983 -7.184,-0c-0.991,-0.991 -1.486,-2.29 -1.487,-3.589l-0,-3.7c0.001,-1.299 0.498,-2.598 1.489,-3.59c0.992,-0.991 2.291,-1.488 3.59,-1.489c0.258,-0 0.516,0.098 0.713,0.295c0.394,0.394 0.394,1.033 -0,1.427c-0.197,0.197 -0.455,0.296 -0.713,0.296c-0.783,0.001 -1.566,0.3 -2.163,0.898c-0.598,0.597 -0.897,1.38 -0.898,2.163l0,3.701c0,0.783 0.299,1.566 0.897,2.164c1.195,1.195 3.133,1.195 4.329,-0c0.597,-0.598 0.896,-1.381 0.896,-2.165l0,-1.523Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBLink);
export default __webpack_public_path__ + "static/media/iconB-link.165e40087a3b0c93f7179097ad71bcfd.svg";
export { ForwardRef as ReactComponent };